require('dotenv').config()
const REACT_APP_BACKEND_URL= `${process.env.REACT_APP_BACKEND_URL}`;
const REACT_APP_ENVIRONMENT= `${process.env.REACT_APP_ENVIRONMENT}`;
const REACT_APP_CONTINGENCY_ON= `${process.env.REACT_APP_CONTINGENCY_ON}`;
const REACT_APP_STRIPE_KEY= `${process.env.REACT_APP_STRIPE_KEY}`;
const REACT_APP_PEKELACH_ORDERING_DONE= `${process.env.REACT_APP_PEKELACH_ORDERING_DONE}`;
const REACT_APP_ORGS= `${process.env.REACT_APP_ORGS}`;

// Parse the organizations map from environment variable
// Expected format: "subdomain1:id1,subdomain2:id2" or JSON string
const parseOrgsMap = () => {
  const orgsMap = {};
  REACT_APP_ORGS.split(',').forEach(pair => {
    const [subdomain, id] = pair.split(':');
    if (subdomain && id) {
      orgsMap[subdomain.trim()] = id.trim();
    }
  });
  return orgsMap;
};

const ORGS_MAP = parseOrgsMap();

// Get subdomain from current URL
const getSubdomain = () => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.');
  // If hostname is localhost or just ezpurim.com (2 parts), no subdomain
  if (parts.length <= 2 || hostname.includes('localhost')) {
    return null;
  }
 
  // Return the first part as subdomain (e.g., 'ti' from 'ti.ezpurim.com')
  return parts[0];
};

// Determine ORG_ID based on subdomain
const determineOrgId = () => {
  const subdomain = getSubdomain();
 
  if (subdomain && ORGS_MAP[subdomain]) {
    return ORGS_MAP[subdomain];
  }

  // Fall back to default org or env variable
  return ORGS_MAP['default'];
};


export const CONTINGENCY_ON = (REACT_APP_CONTINGENCY_ON || 'false') === 'true';
export const ORG_ID = determineOrgId();
export const PEKELACH_ORDERING_DONE =
  (REACT_APP_PEKELACH_ORDERING_DONE || 'false') === 'true';
export const STRIPE_KEY = REACT_APP_STRIPE_KEY;
export const BACKEND_URL =
  REACT_APP_BACKEND_URL || 'https://ezpurim-api.herokuapp.com/';

export const ENVIRONMENT = REACT_APP_ENVIRONMENT || 'local';

export const JWT_KEY = `ezp.jwt.${ENVIRONMENT}`;
export const USER_FULLNAME_KEY = `ezp.fullname.${ENVIRONMENT}`;
export const USER_LASTNAME_KEY = `ezp.lastname.${ENVIRONMENT}`;
export const USER_PHONE_NUMBER = `ezp.phoneNumber.${ENVIRONMENT}`;
export const PERSONAL_GREETINGS = `ezp.greetings.${ENVIRONMENT}`;
export const CUSTOMER_ID = `ezp.customer.${ENVIRONMENT}`;

export const DATE_END_PEKELACH = 15;
